export default __webpack_public_path__ + "static/media/ART17.c1b711f8.jpg";